
import { TimelineMax,TweenMax, Linear, Sine} from "gsap";
// TimelineMax, Power2, Elastic, CSSPlugin ,Tweenmax

export function play(){
  //雷達
  let tl = new TimelineMax()
  tl.staggerTo(`[data-name="雷達"] path`,0.3,{
    opacity: 0,
    ease: Linear.easeNone
  },0.5)
  tl.repeat(-1)

  //手
  TweenMax.to(`[data-name="Layer 11"]`,1,{
    opacity: 0
  }).repeat(-1).yoyo(true)

  TweenMax.set(`[data-name="學生"] [data-name="頭"]`,{
    transformOrigin:"50% 100%"
  })
  TweenMax.to(`[data-name="學生"] [data-name="頭"]`,3,{
    y: 2,
    rotate: -5
  }).repeat(-1).yoyo(true)

  let leftHand = `[data-name="學生"] .bfcf1822-5057-4298-b589-251b51f8a485:nth-child(8)`
  TweenMax.set(leftHand,{
    transformOrigin:"100% 0%"
  })
  TweenMax.to(leftHand,1,{
    rotate: -3,
    scaleY: 1.03,
  }).repeat(-1).yoyo(true)

  
  let rightHand = `[data-name="學生"] .bfcf1822-5057-4298-b589-251b51f8a485:nth-child(9)`
  TweenMax.set(rightHand,{
    transformOrigin: "100% 0%"
  })
  TweenMax.to(rightHand,2,{
    rotate: -8,
  }).repeat(-1).delay(1).yoyo(true)

  // 學生證
  TweenMax.to(`[data-name="card"]`,2,{
    x: 15,
    y: 5,
    ease: Linear.easeNone
  }).repeat(-1).yoyo(true)

  // TweenMax.set(`.ea90f06c-c01b-452b-b1d5-6a25bd2d6f39`,{
  //   "stroke-dasharray": "22.84 22.84"
  // })

  // TweenMax.to(`.fc2c5b1b-12b1-40c4-bd7a-9d0ed9ebba7d, .ea90f06c-c01b-452b-b1d5-6a25bd2d6f39`,1,{
  //   "stroke-dashoffset": -45,
  //   ease: Linear.easeNone
  // }).repeat(-1)

  TweenMax.to(`[data-name="學生"]:nth-child(1) `,0.5,{
    y: -30,
    x: 5,
    ease: Linear.easeNone
  },1).repeat(-1).yoyo(true)
  

}